export default {
  API_ENDPOINT: 'https://sleepy-temple-89186.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
}

// 'https://sleepy-temple-89186.herokuapp.com/'
// 'http://localhost:8000/api',